import { render, staticRenderFns } from "./chat_zxjl.vue?vue&type=template&id=791933fc&scoped=true&"
import script from "./chat_zxjl.vue?vue&type=script&lang=js&"
export * from "./chat_zxjl.vue?vue&type=script&lang=js&"
import style0 from "./chat_zxjl.vue?vue&type=style&index=0&id=791933fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791933fc",
  null
  
)

export default component.exports